import React, { useEffect } from "react";
import { Header } from "../../components/Header/Header";
import { Loader } from "../../templates/Loader/Loader";
import { useDynatrace } from "../../hooks/useDynatrace";

export const Page = ({ onSimulationComplete }) => {
  const _onSimulationComplete = () => {
    onSimulationComplete();
  };

  const {} = useDynatrace();

  useEffect(() => {
    setTimeout(_onSimulationComplete, 2500);
  }, []);

  return (
    <div className="container-page --bg-yellow">
      <Header customClasses="" />

      <Loader />
    </div>
  );
};
